export const GET_QUICKSCREEN_ELIGIBLITY_CHECK = 'GET_QUICKSCREEN_ELIGIBLITY_CHECK';
export const RESET_QUICKSCREEN_ELIGIBLITY = 'RESET_QUICKSCREEN_ELIGIBLITY';
export const GET_QUICKSCREEN_ELIGIBLITY_CHECK_SUCCESS = 'GET_QUICKSCREEN_ELIGIBLITY_CHECK_SUCCESS';
export const GET_QUICKSCREEN_ELIGIBLITY_CHECK_FAILURE = 'GET_QUICKSCREEN_ELIGIBLITY_CHECK_FAILURE';
export const UPDATE_QUICKSCREEN_WIDGET_DETAILS = 'UPDATE_QUICKSCREEN_WIDGET_DETAILS';
export const UPDATE_QUICKSCREEN_WIDGET_DETAILS_SUCCESS =
    'UPDATE_QUICKSCREEN_WIDGET_DETAILS_SUCCESS';
export const QUICKSCREEN_ANALYTICS_EVENT = 'QUICKSCREEN_ANALYTICS_EVENT';
export const WEB_GET_REWARD_PROFILE_REQUEST_QS = 'WEB_GET_REWARD_PROFILE_REQUEST_QS';
export const WEB_OPEN_QUICK_SCREEN_REQUEST = 'WEB_OPEN_QUICK_SCREEN_REQUEST';
export const LOAD_SYF_QUICKSCREEN_SCRIPT = 'LOAD_SYF_QUICKSCREEN_SCRIPT';
export const UPDATE_QS_WIDGET_STATUS = 'UPDATE_QS_WIDGET_STATUS';
